import { render, staticRenderFns } from "./EditStudentModal.vue?vue&type=template&id=9c857fb2&"
import script from "./EditStudentModal.vue?vue&type=script&lang=js&"
export * from "./EditStudentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports